module.exports = __webpack_public_path__ + "img/logo-landpage.261766c9.svg";